define([
	"dojo/_base/declare",
	"csi/heading/Attribute",
	"csi/locale"
], function(declare,Attribute,locale) {

	return declare(Attribute, {
		// String: value to display for errors
		_error: null,
		
		constructor: function() {
			this._error = locale.resource("ERROR");
		},
		
		toValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: only display actual error in tooltip; for cell just indicate there is an error
  			return this._error;
		},

		toTooltip: function(/*Context*/ctx, /*Heading*/h, /*Tooltip*/tooltip) {
			// summary: show error value
			tooltip.setContent(this._getValue(ctx, h));
		}
	});
});